module.exports = __webpack_public_path__ + "static/media/cal-female-condom.6f4807ff.jpg";